angular.module('zc.projects')

.constant 'maxIncentiveInterval',
  1

.directive 'zcCampaignIncentiveWarning', ($translate, maxIncentiveInterval) ->
  restrict: 'E'
  scope:
    campaign: '='
  template: """
  <div
    style="font-size: 1.2em;"
    class="alert alert-warning"
    role="alert"
    ng-repeat="message in messages">
    <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
    {{message}}
  </div>
  """

  link: (scope, element, attrs) ->
    scope.messages = []
    checkWarnings = (newval)->
      return if !newval

      scope.messages = []
      if scope.campaign.delivery_type_option?.id is 'complete_delivery'
        scope.messages.push $translate.instant('projectsCampaigns.directives.campaignIncentiveWarning.canNotEditIncentiveSetting')
        return

      return unless scope.campaign.requires_incentives

      if scope.campaign.incentives.length is 0
        scope.messages.push $translate.instant('projectsCampaigns.directives.campaignIncentiveWarning.noIncentiveRegistered')
        return

      if scope.campaign.start_at_obj && moment(scope.campaign.incentives[0].start_at).diff(moment(scope.campaign.start_at_obj.date), 'days') >= maxIncentiveInterval
        scope.messages.push $translate.instant('projectsCampaigns.directives.campaignIncentiveWarning.startDaysAppartCampaignAndIncentive', { maxIncentiveInterval: maxIncentiveInterval })
      if (scope.campaign.end_at_obj && !scope.campaign.is_infinite &&
          moment(scope.campaign.end_at_obj.date).diff(moment(scope.campaign.incentives[scope.campaign.incentives.length-1].end_at), 'days') >= maxIncentiveInterval)
        scope.messages.push $translate.instant('projectsCampaigns.directives.campaignIncentiveWarning.endDaysAppartCampaignAndIncentive', { maxIncentiveInterval: maxIncentiveInterval })

      long_interval = false
      for incentive, i in scope.campaign.incentives[1..]
        prev_incentive = scope.campaign.incentives[i]
        if moment(incentive.start_at).diff(moment(prev_incentive.end_at), 'days') >= maxIncentiveInterval
          long_interval = true
      if long_interval
        scope.messages.push $translate.instant('projectsCampaigns.directives.campaignIncentiveWarning.incentiveDeliveryInterval', { maxIncentiveInterval: maxIncentiveInterval })

    checkWarnings()
    scope.$watch 'campaign', checkWarnings, true



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_incentive_warning.directive.coffee